import Axios from "axios";

const state = {
    sections: [],
    markets: [],
    isFilterVisible: false,
    isSectionEditVisible: false,
    sectionIdMaster: null,
    isDocumentEditVisible: false,
    documentCodes: [],
    isUploadDocumentVisible: false,
    isShareTokenFormVisible: false,
    shareTokensDocumentIdMasters: []
};

const getters = {
    sections: state => state.sections,
    markets: state => state.markets,
    isFilterVisible: state => state.isFilterVisible,
    isSectionEditVisible: state => state.isSectionEditVisible,
    sectionIdMaster: state => state.sectionIdMaster,
    isDocumentEditVisible: state => state.isDocumentEditVisible,
    documentCodes: state => state.documentCodes,
    isUploadDocumentVisible: state => state.isUploadDocumentVisible,
    isShareTokenFormVisible: state => state.isShareTokenFormVisible,
    shareTokensDocumentIdMasters: state => state.shareTokensDocumentIdMasters
};

const mutations = {
    setSections: (state, data) => state.sections = data,
    setMarkets: (state, data) => state.markets = data,
    setFilterVisible: (state, data) => state.isFilterVisible = data,
    setSectionEditVisible: (state, data) => state.isSectionEditVisible = data,
    setSectionIdMaster: (state, data) => state.sectionIdMaster = data,
    setDocumentEditVisible: (state, data) => state.isDocumentEditVisible = data,
    setDocumentCodes: (state, data) => state.documentCodes = data,
    setUploadDocumentVisible: (state, data) => state.isUploadDocumentVisible = data,
    setShareTokenFormVisible: (state, data) => state.isShareTokenFormVisible = data,
    setShareTokensDocumentIdMasters: (state, data) => state.shareTokensDocumentIdMasters = data
};

const actions = {
    getSections: async (context, data) => {
        const response = (await Axios.post((<any>window).App.routes.MyBremboPartsFileSharing_GetSectionsData, data)).data;
        context.commit("setSections", response);
    },
    getMarkets: async (context, data) => {
        const response = (await Axios.post((<any>window).App.routes.MyBremboPartsFileSharing_GetMarkets, data)).data;
        context.commit("setMarkets", response);
    },
    getShareTokensDocumentIdMasters: (context) => {
        context.commit("setShareTokensDocumentIdMasters", JSON.parse(window.localStorage.getItem('shareTokensDocumentIdMasters')) ?? []);
    },
    saveShareTokensDocumentIdMasters: (context) => {
        window.localStorage.setItem('shareTokensDocumentIdMasters', JSON.stringify(context.getters["shareTokensDocumentIdMasters"]));
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};